export const CATALOG_SEARCH_TERM_KEY = 'search'
export const CATALOG_FULFILLMENT_TYPES_KEY = 'fulfillmentTypes'
